import { _t } from "core/language";
import Section from "core/components/Section";
import { Button } from "core/components/form-controls";
import { RouterName } from "core/router";
import { Fragment } from "react";
// import AiRecipeIngredients from "./../components/RecipeIngredients";
import AiHowToCook from "./../components/HowToCook";
import {
  useRecipeDetail,
  useGoToRecipeDetail,
} from "modules/Recipes/hooks/recipe";

const AiRecipeDetail = ({ id }: any) => {
  const { loading, data } = useRecipeDetail(id)
  const goToDetail = useGoToRecipeDetail(RouterName.AI_CHEF_RECIPE_DETAIL)

  return (
    <Fragment>
      {/*<Section className="px-4 pt-2.5 pb-[30px]">*/}
        {/*<div className="flex flex-col gap-2.5 pb-3.5">
          <AiHowToCook recipe={data} loading={loading} />
        </div>*/}
      {/*</Section>*/}
      <Section className="px-4 py-[30px]">
        <div className="flex flex-col gap-[30px]">
          {/*<AiRecipeIngredients recipe={data} loading={loading} />*/}
          <AiHowToCook recipe={data} loading={loading} />
          {!loading ? (<Button
            label={_t('aiChef.recipe.go_to_detail')}
            classBtn="w-full"
            primary
            outline
            onClickBtn={() => goToDetail(data)}
          />) : null}
        </div>
      </Section>
    </Fragment>
  )
};

export default AiRecipeDetail;
